import { STORYBOARD_TYPES } from "src/pages/experiences/types";

export function formatStoryboardType(type: string | undefined): string {
  if (!type) return "";

  switch (type) {
    case STORYBOARD_TYPES.SPATIAL:
      return "Spatial";
    case STORYBOARD_TYPES.FLIP_BOOK:
      return "Flipbook";
    case STORYBOARD_TYPES.INTERACTIVE_CONTENT:
    case STORYBOARD_TYPES.INTERACTIVE_CONTENT_V2:
      return "Interactive Content";
    case STORYBOARD_TYPES.LANDING_PAGE:
      return "Landing Page";
    case STORYBOARD_TYPES.RESOURCE_CENTER:
      return "Resource Center";
    default:
      return type
        .split("_")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(" ");
  }
}


export const userDetailsHeader = [
  { label: 'Name', width: 4, value: 'name' },
  { label: 'E-mail', width: 3, value: 'email' },
  { label: 'Role', width: 2, value: 'role' },
  { label: 'Last Active', width: 2, value: 'lastActivity' },
  { label: '', width: 1, value: 'remove' },
];